import React from "react";
import "./About.scss";
import { TiDownloadOutline } from "react-icons/ti";
import { Link } from "react-router-dom";

const About = () => {
    return (
        <section className="about" id="about">
            <div className="about__bg bgImg">
                <img className="bgImg" src="./images/about.png" alt="about" />
            </div>
            <div className="about__intro">
                <h6>INTRODUCTION</h6>
                <h1>ABOUT ME</h1>
                <p>
                    I'm very passionate and dedicated to my work. After
                    exploring computer science, I found love in Web
                    technologies. Currently, I use javascript frameworks to
                    build websites from scratch. I am capable to build
                    responsive and high-performing websites for any
                    organization. Strong engineering professional with a
                    Bachelor of Engineering focused in Computer Science from
                    Ahsanullah University of Engineering & Technology.
                </p>
                <button className="about__intro--resume">
                    <span>
                        <Link
                            to="/resume_ShamsulHaque.pdf"
                            target="_blank"
                            rel="pdf"
                            download="resume_ShamsulHaque"
                        >
                            RESUME
                        </Link>
                    </span>
                    <TiDownloadOutline />
                </button>
            </div>
        </section>
    );
};

export default About;
